import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Axios from "axios";
import GlobalConstant from "@/common/globalconstant.js";
import vuetify from "./plugins/vuetify";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import globalstore from "@/common/globalstore.js";

dayjs.extend(customParseFormat);

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.baseURL = GlobalConstant.API_URL;
Vue.prototype.$http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Vue.prototype.$date = dayjs;

Vue.prototype.$globalstore = globalstore;

Vue.filter("ellipsetext", function(text, length) {
   var result = "";
   if (text) {
      if (text.length <= length) {
         result = text;
      } else {
         result = text.slice(0, length) + "...";
      }
   }
   return result;
});

new Vue({
   router,
   vuetify,
   render: (h) => h(App),
}).$mount("#app");
